import { TripModalComponent } from "./trip-modal/trip-modal.component";
import { TripRowComponent } from "./trip-modal/trip-row/trip-row.component";
import { TripSearchBarComponent } from "./trip-search-bar/trip-search-bar.component";
import { PositionsPlayerComponent } from "./positions-player/positions-player.component";

export {
  TripModalComponent,
  TripRowComponent,
  TripSearchBarComponent,
  PositionsPlayerComponent
};

export const tripComponents = [
  TripModalComponent,
  TripRowComponent,
  TripSearchBarComponent,
  PositionsPlayerComponent
]